<template>
  <div class="footer-box">
    <div class="ax-footer">
      <div class="footer-top">
        <!-- <div class="logo">
          <img src="@/assets/logo.png" alt="">
        </div> -->
        <div class="name">
          <img src="https://homeimage.ksaxshop.com/dfgdfgf.png" alt="" style="width:75px;">
          <div style="text-align: left;padding-left:10px;">
            <h1 style="font-size: 52px;line-height: 1;">营客通</h1>
            <h5 style="line-height: 1;margin-top:5px;">上海赢可通信息科技有限公司</h5>
          </div>
        </div>
        <div class="info-box">
          <p>热线电话：400-663-3315</p>
          <p>工作时间：周一到周日9:00-18:00</p>
          <!-- <p>商务合作邮箱：service@kuaishouaxiu.com</p> -->
          <p>联系地址：上海市杨浦区尚浦汇-T2号楼509</p>
        </div>
        <div class="code-img">
          <img src="@/assets/shop_code.png" alt="" width="120">
          <span>关注领好礼</span>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <div class="address">
        <span>上海赢可通信息科技有限公司版权所有 Copyright ©2015-2021</span>
        <span @click="jumpICP">沪ICP备20008483号-1</span>
        <span @click="jumpPublicSecurity">沪公网安备 31011002005044号</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AXfooter',
  created() {

  },
  methods: {
    jumpICP() {
      window.open('https://beian.miit.gov.cn/#/Integrated/index')
    },
    jumpPublicSecurity() {
      window.open('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011002005044')
    }
  }
}
</script>
<style lang="scss" scoped>
.footer-box {
  background: #fff;

  .ax-footer {
    width: 1200px;
    // height: 260px;
    margin: 0 auto;
    padding-top: 32px;
    padding-bottom: 20px;

    .footer-top {
      font-size: 14px;
      color: #333;
      width: 1000px;
      line-height: 27px;
      display: flex;
      justify-content: space-between;

      .logo {
        width: 191px;
        height: 150px;

        img {
          width: 100%;
          // height: 50%c;
        }
      }

      .info-box {
        text-align: left;

        p {
          margin: 5px 0;
        }
      }

      .code-img {
        img {
          display: block;
        }

        span {
          display: block;
        }
      }
    }
  }

  .footer-bottom {
    background: #333;
    height: 50px;

    .address {
      text-align: center;
      font-size: 14px;
      color: #FFFFFF;
      line-height: 50px;

      span {
        margin-right: 30px;
        cursor: pointer;
      }
    }
  }
}

.name {
  display: flex;
  align-items: center;

  h1 {
    color: red;
  }
}
</style>